import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import LandingPage from "@/pages/LandingPage";
import EngineeringHome from "@/pages/engineering/EngineeringHome";
import EngineeringAbout from "@/pages/engineering/EngineeringAbout";
import EngineeringServices from "@/pages/engineering/EngineeringServices";
import EngineeringPortfolio from "@/pages/engineering/EngineeringPortfolio";
import EngineeringQuote from "@/pages/engineering/EngineeringQuote";
import EngineeringContact from "@/pages/engineering/EngineeringContact";
import OriginalsHome from "@/pages/originals/OriginalsHome";
import OriginalsAbout from "@/pages/originals/OriginalsAbout";
import OriginalsProduct from "@/pages/originals/OriginalsProduct";
import OriginalsCart from "@/pages/originals/OriginalsCart";
import OriginalsCheckout from "@/pages/originals/OriginalsCheckout";
import OrderConfirmation from "@/pages/originals/OrderConfirmation";

// Admin Pages
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminHome from "@/pages/admin/AdminHome";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminPortfolio from "@/pages/admin/AdminPortfolio";
import AdminEnquiries from "@/pages/admin/AdminEnquiries";
import AdminDiscounts from "@/pages/admin/AdminDiscounts";
import AdminSettings from "@/pages/admin/AdminSettings";

// Context
import { CartProvider } from "@/context/CartContext";

// Theme wrapper component
const ThemeWrapper = ({ children }) => {
  const location = useLocation();
  const isOriginals = location.pathname.startsWith('/originals');
  const isAdmin = location.pathname.startsWith('/admin');
  
  // Admin has its own dark theme, skip wrapper
  if (isAdmin) {
    return <>{children}</>;
  }
  
  return (
    <div className={isOriginals ? 'dark' : ''}>
      <div className={`min-h-screen ${isOriginals ? 'bg-[#0a0a0a] text-[#fafafa]' : 'bg-white text-[#0f172a]'}`}>
        {children}
      </div>
    </div>
  );
};

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <ThemeWrapper>
          <Routes>
            {/* Landing */}
            <Route path="/" element={<LandingPage />} />
            
            {/* Engineering Routes */}
            <Route path="/engineering" element={<EngineeringHome />} />
            <Route path="/engineering/about" element={<EngineeringAbout />} />
            <Route path="/engineering/services" element={<EngineeringServices />} />
            <Route path="/engineering/portfolio" element={<EngineeringPortfolio />} />
            <Route path="/engineering/quote" element={<EngineeringQuote />} />
            <Route path="/engineering/contact" element={<EngineeringContact />} />
            
            {/* Originals Routes */}
            <Route path="/originals" element={<OriginalsHome />} />
            <Route path="/originals/about" element={<OriginalsAbout />} />
            <Route path="/originals/product/:id" element={<OriginalsProduct />} />
            <Route path="/originals/cart" element={<OriginalsCart />} />
            <Route path="/originals/checkout" element={<OriginalsCheckout />} />
            <Route path="/originals/order-confirmation" element={<OrderConfirmation />} />
            
            {/* Admin Routes */}
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />}>
              <Route index element={<AdminHome />} />
              <Route path="products" element={<AdminProducts />} />
              <Route path="portfolio" element={<AdminPortfolio />} />
              <Route path="enquiries" element={<AdminEnquiries />} />
              <Route path="discounts" element={<AdminDiscounts />} />
              <Route path="settings" element={<AdminSettings />} />
            </Route>
          </Routes>
        </ThemeWrapper>
        <Toaster />
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
